export default __webpack_public_path__ + "static/media/editpage-dashboard-item.fd8b6f61.png";